export const GET_CHECKERS_REQUEST = 'GET_CHECKERS_REQUEST'
export const GET_CHECKERS_SUCCESS = 'GET_CHECKERS_SUCCESS'
export const GET_CHECKERS_FAIL = 'GET_CHECKERS_FAIL'
export const GET_CHECKERS_RESET = 'GET_CHECKERS_RESET'

export const CREATE_CHECKER_REQUEST = 'CREATE_CHECKER_REQUEST'
export const CREATE_CHECKER_SUCCESS = 'CREATE_CHECKER_SUCCESS'
export const CREATE_CHECKER_FAIL = 'CREATE_CHECKER_FAIL'
export const CREATE_CHECKER_RESET = 'CREATE_CHECKER_RESET'

export const UPDATE_CHECKER_REQUEST = 'UPDATE_CHECKER_REQUEST'
export const UPDATE_CHECKER_SUCCESS = 'UPDATE_CHECKER_SUCCESS'
export const UPDATE_CHECKER_FAIL = 'UPDATE_CHECKER_FAIL'
export const UPDATE_CHECKER_RESET = 'UPDATE_CHECKER_RESET'

export const DELETE_CHECKER_REQUEST = 'DELETE_CHECKER_REQUEST'
export const DELETE_CHECKER_SUCCESS = 'DELETE_CHECKER_SUCCESS'
export const DELETE_CHECKER_FAIL = 'DELETE_CHECKER_FAIL'
export const DELETE_CHECKER_RESET = 'DELETE_CHECKER_RESET'

export const ASSIGN_EVENTS_REQUEST = 'ASSIGN_EVENTS_REQUEST'
export const ASSIGN_EVENTS_SUCCESS = 'ASSIGN_EVENTS_SUCCESS'
export const ASSIGN_EVENTS_FAIL = 'ASSIGN_EVENTS_FAIL'
export const ASSIGN_EVENTS_RESET = 'ASSIGN_EVENTS_RESET'
